var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main-content m-t-3 m-b-3"},[_c('notification'),_c('dash',{attrs:{"user":_vm.user,"top-artists":_vm.topArtists,"recent-tracks":_vm.recentTracks,"recommendet-tracks":_vm.recommendetTracks}}),_c('action-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }